import React, { FC } from 'react'
import IconSVG, { IconSVGProps } from '../IconSVG'

export const IconMinus2: FC<IconSVGProps> = ({ ...props }) => (
  <IconSVG className="IconMinus2" {...props}>
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.8594 8.35938C14.7656 8.45312 14.6406 8.5 14.5 8.5H3.45312H1.5C1.35938 8.5 1.23438 8.45312 1.14062 8.35938C1.04688 8.26562 1 8.14062 1 8C1 7.85938 1.04688 7.73438 1.14062 7.64062C1.23438 7.54688 1.35938 7.5 1.5 7.5H3.46875H14.5C14.6406 7.5 14.7656 7.54688 14.8594 7.64062C14.9531 7.73438 15 7.85938 15 8C15 8.14062 14.9531 8.26562 14.8594 8.35938Z"
        fill="currentColor"
      />
    </svg>
  </IconSVG>
)
